import { fetchWithRetry } from './fetch-with-retry';
import { buildStrapiUrl } from '@/utils/strapi-url';
import type { LocaleLanguage } from '@/lib/locale-context';

export type Localization = {
  id?: number;
  locale: LocaleLanguage | string;
  slug: string;
};

type FetchLocalizationsParams = {
  collection: string;
  slug: string;
  locale: LocaleLanguage | string;
};

const localizationRequests = new Map<string, Promise<Localization[]>>();

export async function fetchLocalizationsBySlug({
  collection,
  slug,
  locale,
}: FetchLocalizationsParams): Promise<Localization[]> {
  const cacheKey = `${collection}:${locale}:${slug}`;
  const cachedRequest = localizationRequests.get(cacheKey);

  if (cachedRequest) {
    return cachedRequest;
  }

  const request = (async () => {
    try {
      const params = new URLSearchParams({
        'filters[slug][$eq]': slug,
        locale,
        populate: 'localizations',
      });

      const res = await fetchWithRetry(
        buildStrapiUrl(`/api/${collection}`, params),
      );

      if (!res.ok) {
        return [];
      }

      const response = await res.json();
      return response?.data?.[0]?.localizations ?? [];
    } catch {
      return [];
    }
  })();

  localizationRequests.set(cacheKey, request);
  return request;
}
